export const resourceMappings = {
  User: {
    buttonText: "Crear Usuario",
    buttonUrl: "/admin/users/new",
    ajaxUrl: "/admin/users.json"
  },
  Client: {
    buttonText: "Crear Cliente",
    buttonUrl: "/admin/clients/new",
    ajaxUrl: "/admin/clients.json"
  },
  WhatsappTemplate: {
    buttonText: "Crear Plantilla",
    buttonUrl: "/admin/whatsapp_templates/new",
    ajaxUrl: "/admin/whatsapp_templates.json"
  },
  CompanyWhatsappNumber: {
    buttonText: "Crear Número",
    buttonUrl: "/admin/company_whatsapp_numbers/new",
    ajaxUrl: "/admin/company_whatsapp_numbers.json"
  },
  Organization: {
    buttonText: "Crear Organización",
    buttonUrl: "/superadmin/organizations/new",
    ajaxUrl: "/superadmin/organizations.json"
  },
  KnowledgeBaseEntry: {
    buttonText: "Nueva Entrada",
    buttonUrl: "/admin/knowledge_base_entries/new",
    ajaxUrl: "/admin/knowledge_base_entries.json"
  },
  Ticket: {
    buttonText: "Crear Ticket",
    buttonUrl: "/admin/tickets/new",
    ajaxUrl: "/admin/tickets.json"
  }
}
